var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4903 10.4017C15.4709 10.3049 15.4234 10.216 15.3536 10.1462L5.35355 0.146168C5.15829 -0.0490935 4.84171 -0.0490934 4.64645 0.146169L0.646446 4.14617C0.451184 4.34143 0.451184 4.65801 0.646446 4.85328L3.14593 7.35276C3.1461 7.35293 3.14576 7.35259 3.14593 7.35276C3.1461 7.35293 3.14679 7.35362 3.14696 7.35379L10.6464 14.8533C10.7162 14.9231 10.8051 14.9707 10.9019 14.99L15.9019 15.99C16.2518 16.06 16.5603 15.7515 16.4903 15.4017L15.4903 10.4017ZM4.20711 6.99972L11.2465 14.0391L15.3626 14.8623L14.5394 10.7462L7.5 3.70683L4.20711 6.99972ZM3.5 6.29262L6.79289 2.99972L5 1.20683L1.70711 4.49972L3.5 6.29262Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen_icon.7ec7c40c553864fc591a6f8441e74b5e.svg";
export { ForwardRef as ReactComponent };